/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beautify adds indentation and line breaks to make JSON readable; minify removes all unnecessary whitespace to make it as small as possible.`)
};

const es_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embellecer añade indentación y saltos de línea para hacer JSON legible; minificar elimina todo espacios en blanco innecesarios para hacerlo lo más pequeño posible.`)
};

const de_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatieren fügt Einzug und Zeilenumbrüche hinzu, um JSON lesbar zu machen; Minimieren entfernt alle unnötigen Leerzeichen, um es so klein wie möglich zu machen.`)
};

const nl_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mooi maken voegt inspringing en regelonderbrekingen toe om JSON leesbaar te maken; minimaal verwijdert alle onnodige witruimte om het zo klein mogelijk te maken.`)
};

const fr_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'embellissement ajoute l'indentation et les sauts de ligne pour rendre le JSON lisible ; la minification supprime tous les espaces inutiles pour le rendre aussi petit que possible.`)
};

const it_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La formattazione aggiunge indentazione e interruzioni di riga per rendere JSON leggibile; la minimizzazione rimuove tutti gli spazi bianchi non necessari per renderlo il più piccolo possibile.`)
};

const pt_br2_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embelezar adiciona indentação e quebras de linha para tornar JSON legível; minificar remove todo espaço em branco desnecessário para torná-lo o menor possível.`)
};

const pt_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embelezar adiciona indentação e quebras de linha para tornar JSON legível; minificar remove todo o espaço em branco desnecessário para torná-lo o mais pequeno possível.`)
};

const ja_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beautifyはインデンテーションと改行を追加してJSONを読みやすくします。minifyはすべての不要な空白を削除して可能な限り小さくします。`)
};

const zh_jf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美化会添加缩进和换行，让 JSON 更易读；压缩则会去除所有不必要的空白，使其体积尽可能小。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_faq3_a", locale)
	if (locale === "en") return en_jf_faq3_a(inputs)
	if (locale === "es") return es_jf_faq3_a(inputs)
	if (locale === "de") return de_jf_faq3_a(inputs)
	if (locale === "nl") return nl_jf_faq3_a(inputs)
	if (locale === "fr") return fr_jf_faq3_a(inputs)
	if (locale === "it") return it_jf_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_jf_faq3_a(inputs)
	if (locale === "pt") return pt_jf_faq3_a(inputs)
	if (locale === "ja") return ja_jf_faq3_a(inputs)
	return zh_jf_faq3_a(inputs)
};